import { StateCreator } from "zustand";
import { IAppState, ILoadingState } from "../types";

const createLoadingSlice: StateCreator<
    IAppState,
    [["zustand/devtools", never], ["zustand/persist", unknown], ["zustand/immer", never]],
    [],
    ILoadingState
    > = (set) => {
    return {
        loading: false,
        setLoading: (loading) => {
            set(state => {
                state.loading = loading;
            })
        }
    }
};

export default createLoadingSlice;